import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { QueryFunction } from '@tanstack/react-query';

export interface CrossValidatorMappingSource {
  form: string;
  field: string;
}

export interface CrossValidatorMapping {
  name: string;
  sources: CrossValidatorMappingSource[];
}

interface CrossValidatorMappingRaw {
  id: string;
  type: string;
  mapping: {
    name: string;
    sources?: CrossValidatorMappingSource[];
  };
  createdAt: string;
  updatedAt: string;
}

interface CrossValidatorMappingsResponse {
  success: boolean;
  mappings: CrossValidatorMappingRaw[];
}

const getCrossValidatorMappings: QueryFunction<
  CrossValidatorMapping[],
  ['/cross-validator-mappings']
> = async () => {
  if (isMockServices()) return await mock(_mockData);
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<CrossValidatorMappingsResponse>(
    '/mappings/Cross-Validator-Mappings',
    {
      method: 'GET',
    },
  );
  if (response.data) {
    return response.data.mappings.map((mapping) => ({
      name: mapping.mapping.name,
      sources: mapping.mapping.sources ?? [],
    }));
  }
  throw new Error('Failed to fetch cross-validator mappings');
};

export default getCrossValidatorMappings;

// Mock data for development
const _mockData: CrossValidatorMapping[] = [
  {
    name: 'Married Checkbox',
    sources: [{ form: 'URLA - Borrower Information', field: 'Sec1a_Married' }],
  },
];
